import { connect } from "react-redux";
import { updateProspect, updateRoProspect } from "../../../../../../store/actions/appConfig";
import { getOrganizationInfoRO } from "../../../../../../store/selectors/appConfig";

import { CompanyAnticipatedTransactionComponent } from "./CompanyAnticipatedTransaction";

const mapStateToProps = state => ({
  anticipatedTransactionsDetails: getOrganizationInfoRO(state).anticipatedTransactionsDetails
});

const mapDispatchToProps = {
  updateProspect,
  updateRoProspect
};

export const CompanyAnticipatedTransaction = connect(
  mapStateToProps,
  mapDispatchToProps
)(CompanyAnticipatedTransactionComponent);
